import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, BookOpen, Menu, X } from 'lucide-react';
import '../styles/Home.css';
import '../styles/Free.css';

const Free = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const bullets = [
    "Why saving no longer feels like enough",
    "What inflation is really doing to your time and energy",
    "Why the system feels harder than it used to",
    "A calmer way to start thinking about Bitcoin",
    "One clear next step if this resonates"
  ];

  return (
    <div className="gybtc-container">
      {/* Header */}
      <header className={`gybtc-header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="gybtc-header-content">
          <div className="gybtc-logo-container">
            <Link to="/">
              <img
                src="/gybtc-logo.png"
                alt="Grow Your BTC Logo"
                className="gybtc-logo"
              />
            </Link>
          </div>

          <nav className={`gybtc-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <Link 
              to="/" 
              className="gybtc-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>
            <a
              href="https://growyourbtc.gumroad.com/l/10rules"
              className="gybtc-btn-nav-cta"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMobileMenuOpen(false)}
            >
              Get the Rule Book
            </a>
          </nav>

          <button
            className="gybtc-mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      {/* Hero / Main Content */}
      <section className="gybtc-free-hero">
        {/* Background glow effect */}
        <div className="gybtc-free-bg-glow" />

        <div className="gybtc-free-content">
          {/* Icon */}
          <div className="gybtc-free-icon">
            <BookOpen size={48} />
          </div>

          {/* Headline */}
          <p className="gybtc-free-eyebrow">Get the free guide</p>
          <h1 className="gybtc-free-title">
            You Never Owned Your Money
          </h1>

          {/* Subheadline */}
          <p className="gybtc-free-subtitle">
            A quiet truth about money, savings, and why so many people feel like they're working harder… but getting nowhere.
          </p>

          {/* Email Signup Form - Uses same IDs as main newsletter for MailerLite bridge */}
          <form id="newsletter-form" className="gybtc-free-form" noValidate>
            <input
              id="newsletter-email"
              type="email"
              name="email"
              placeholder="Enter your email address"
              required
              className="gybtc-free-input"
            />
            <button type="submit" className="gybtc-free-btn">
              Get the Free Guide
              <ChevronRight size={20} />
            </button>
          </form>

          {/* Toast notification */}
          <div id="newsletter-toast" style={{ display: 'none' }}></div>

          {/* CTA description */}
          <p className="gybtc-free-cta-text">
            Enter your email to get the free guide and join the GrowYourBTC newsletter.
          </p>

          {/* Bullets */}
          <div className="gybtc-free-bullets">
            <p className="gybtc-free-bullets-title">What you'll understand:</p>
            <ul className="gybtc-free-bullets-list">
              {bullets.map((bullet, index) => (
                <li key={index} className="gybtc-free-bullet-item">
                  <span className="gybtc-free-bullet-icon">→</span>
                  {bullet}
                </li>
              ))}
            </ul>
          </div>

          {/* Trust line */}
          <p className="gybtc-free-trust">
            No spam. Just practical insights, occasional updates, and a calmer path forward.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="gybtc-footer">
        <div className="gybtc-footer-content">
          <p className="gybtc-footer-text">
            © 2025 Grow Your BTC{" • "}
            <Link to="/privacy">Privacy Policy</Link>{" • "}
            <Link to="/terms">Terms</Link>{" • "}
            <Link to="/disclaimer">Disclaimer</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Free;
